import { render, staticRenderFns } from "./Lingua.vue?vue&type=template&id=2544ff5d&scoped=true&"
import script from "./Lingua.vue?vue&type=script&lang=js&"
export * from "./Lingua.vue?vue&type=script&lang=js&"
import style0 from "./Lingua.vue?vue&type=style&index=0&id=2544ff5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544ff5d",
  null
  
)

export default component.exports